module.exports = __webpack_public_path__ + "static/media/live-map.a78bea54.svg";